export default "__VITE_ASSET__btYR102K__"